// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"normalSidebar_sidebar__3Y8dW","sbImgbox":"normalSidebar_sbImgbox__Sa_jW","sbIcontxt":"normalSidebar_sbIcontxt__GQ5mZ"};